// Central data loader. Applies hand-curated overrides to raw transform
// output so consumers see a single canonical shape.

import abilitiesRaw from './abilities.json';
import abilityOverridesRaw from './ability_overrides.json';
import virtuesRaw from './virtues.json';
import flawsRaw from './flaws.json';
import artsRaw from './arts.json';
import housesRaw from './houses.json';
import spellsRaw from './spells.json';
import manifestRaw from './manifest.json';
import houseBenefitsRaw from './house_benefits.json';
import type { Ability, Virtue, Flaw, HermeticArt, House, Spell } from '@/types/data';

const overrides = (abilityOverridesRaw as { overrides: Record<string, Partial<Ability>> }).overrides;

export const abilities: Ability[] = (abilitiesRaw as unknown as Ability[]).map((a) =>
  overrides[a.id] ? { ...a, ...overrides[a.id] } : a
);
export const virtues = virtuesRaw as unknown as Virtue[];
export const flaws = flawsRaw as unknown as Flaw[];
export const arts = artsRaw as unknown as HermeticArt[];
export const houses = housesRaw as unknown as House[];
export const spells = spellsRaw as unknown as Spell[];
export const manifest = manifestRaw as {
  generatedAt: string;
  counts: Record<string, number>;
};
export const houseBenefits = houseBenefitsRaw as {
  benefits: Record<string, unknown>;
};

export const abilityById = new Map(abilities.map((a) => [a.id, a]));
export const virtueById = new Map(virtues.map((v) => [v.id, v]));
export const flawById = new Map(flaws.map((f) => [f.id, f]));
export const artById = new Map(arts.map((a) => [a.id, a]));
export const houseById = new Map(houses.map((h) => [h.id, h]));
